import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BidsAllowedDirective } from './bids-allowed.directive';

@NgModule({
  declarations: [BidsAllowedDirective],
  exports: [BidsAllowedDirective],
})
export class BidsAllowedDirectiveModule {}
